// extracted by mini-css-extract-plugin
export default {"container":"styles_container__g3u9s","firstColumn":"styles_firstColumn__pxej9","secondColumn":"styles_secondColumn__jpnN6","inspectRateLink":"styles_inspectRateLink__yypo6"};